import moment from 'moment';

const OperationsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const getStatus = (i) => {
    if (i?.status === 'status_new') {
      if (moment().isAfter(moment(i?.date_from, 'YYYY-MM-DD'), 'day')) {
        return 'status_expired';
      } else {
        return 'status_new';
      }
    } else {
      return i?.status;
    }
  };

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i.company?.shopping_center?.title,
    'companies.title': i?.company?.title,
    created_at: moment(i?.created_at).format('DD/MM/YYYY HH:mm'),
    status: getStatus(i),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export const FormValuesAdapter = (values) => {
  const formData = new FormData();
  for (let key in values) {
    switch (key) {
      case 'date_to':
      case 'date_from': {
        if (values[key]) {
          formData.append(
            `facility_operation[${key}]`,
            values[key].format('YYYY-MM-DD'),
          );
        }
        break;
      }
      case 'time_from':
      case 'time_to': {
        if (values[key]) {
          formData.append(
            `facility_operation[${key}]`,
            values[key].format('YYYY-MM-DD HH:mm:00'),
          );
        }
        break;
      }
      case 'car_type':
      case 'center_capacity':
      case 'company_contract_person':
      case 'company_phone':
      case 'driver':
      case 'driver_contact':
      case 'vehicle_number':
      case 'worker_quantity':
      case 'company_name': {
        formData.append(
          `facility_operation[facility_operation_additional_attributes][${key}]`,
          values[key] || '',
        );
        break;
      }
      case 'files': {
        if (values[key] && values[key].length > 0) {
          values[key].forEach((i) => {
            formData.append(`facility_operation[${key}][]`, i.originFileObj);
          });
        } else {
          formData.append(`facility_operation[${key}]`, []);
        }
        break;
      }
      default: {
        formData.append(`facility_operation[${key}]`, values[key] || '');
      }
    }
  }
  return formData;
};

export default OperationsAdapter;
